module.exports = __webpack_public_path__ + "static/img/popup_20260728.d695ce2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/popup_20260728.jpg
// module id = VXsj
// module chunks = 1